import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Redux
import { connect } from 'react-redux';

// Style
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './PhotosList.css';
import { Flex, Box } from 'rebass';
import { colors } from './../../../tailwind';
import styled from 'styled-components';
import { buildPhotoPath } from '../../../helpers/photoutils';
import { observer } from 'mobx-react';

const ItemContainer = styled(Box)`
  position: relative;
  height: 150px;
  width: auto;
`;
const PhotoItem = styled.img`
  height: 150px;
  width: auto;
  background-size: 150px 150px;
`;
const CoverBanner = styled(Box)`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #30b5cc;
  text-align: center;
  z-index: 9999999;
`;

const RemoveIcon = styled(Box)`
  position: absolute;
  top: -7px;
  right: -7px;
  background-color: transparent;
  text-align: center;
  z-index: 9999999;
  opacity: 0;
  cursor: pointer;
  color: ${colors.secondary};

  ${ItemContainer}:hover & {
    opacity: 1;
  }
`;

const SortableItem = observer(
  ({ value, isCover, remove, listId, name, makeCover }) => (
    <div style={{ textAlign: 'center' }} className="m-s">
      <ItemContainer>
        <PhotoItem src={value} />
        {isCover ? <CoverBanner>Cover Photo</CoverBanner> : null}
        <RemoveIcon onClick={() => remove(name, true)}>
          <i className="fa fa-times-circle fa-lg" />
        </RemoveIcon>
      </ItemContainer>
      <a
        href="javascript:void(0);"
        onClick={() => {
          makeCover(name);
        }}
        style={{
          color: colors.grayMedium,
          fontSize: '14px',
          fontFamily: 'Helvetica',
          textAlign: 'center',
        }}
      >
        Use as cover photo
      </a>
    </div>
  ),
);
// removeListingPhotos

export const SortableList = observer(
  ({ items, removeListingPhoto, listId, makeCover, coverPhotoName }) => {
    return (
      <Flex flexWrap="wrap" flexDirection="row" width="100%" mb={4} mt={4}>
        {items.map((value, index) => (
          <SortableItem
            key={'item-' + index}
            index={index}
            value={buildPhotoPath('x_medium', value.name)}
            isCover={value.name === coverPhotoName}
            remove={removeListingPhoto}
            makeCover={makeCover}
            listId={listId}
            name={value.name}
          />
        ))}
      </Flex>
    );
  },
);

@observer
class PhotosList extends Component {
  static propTypes = {
    removeListingPhoto: PropTypes.func,
    listId: PropTypes.number,
  };

  makeCover = name => {
    this.props.store.coverPhotoName = name;
    this.props.store.updatePhotoOrder();
  };

  render() {
    const { removeListingPhoto, store } = this.props;
    const { photos, coverPhotoName } = store;

    return (
      <SortableList
        axis="xy"
        distance={20}
        items={photos}
        removeListingPhoto={removeListingPhoto}
        listId={store.listId}
        makeCover={this.makeCover}
        coverPhotoName={coverPhotoName}
      />
    );
  }
}

export default withStyles(s)(PhotosList);



// WEBPACK FOOTER //
// ./src/components_new/addListing/PhotosList/PhotosList.js